import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, exhaustMap, map} from 'rxjs/operators';
import {interval, of} from 'rxjs';
import {TranslationConfig} from '../translation.config';

@Injectable()
export class MissingTranslationSaverService {
  private keys: Array<string> = [];

  constructor(private http: HttpClient, config: TranslationConfig) {
    const storeInterval = 3000;
    interval(storeInterval)
      .pipe(
        exhaustMap(() => {
          const localKeys = [...this.keys];
          if (localKeys && localKeys.length > 0) {
            this.keys.length = 0;
            console.log('Language service storing missing keys', localKeys);
            // send the missing keys
            const headers = {
              'content-type': 'application/json',
              'errors': 'silent'
            };
            return this.http
              .post(
                `${config.apiUrl}/translations/safe-checkin/translations/missing`,
                JSON.stringify(localKeys),
                {'headers': headers}
              )
              .pipe(
                map(() => of(1)),
                catchError(() => {
                  this.keys = [...this.keys, ...localKeys];
                  return of(0);
                })
              );
          } else {
            return of(0);
          }
        })
      )
      .subscribe();
  }

  public addKey(key: string) {
    if (!this.keys.some((x) => x === key)) {
      this.keys.push(key);
    }
  }
}
